<div>
    <plotly-plot (afterPlot)="animated($event)"  #plotly [data]="graph?.data" [layout]="graph?.layout" [config]="graph?.config"></plotly-plot>
</div>